import React, { useEffect, useState } from 'react'
import { supabase } from 'utils/supabase'
import { useParams } from 'react-router-dom'
import CharityCandidateForm from 'admin/components/CharityCandidateForm'
import AdminPageWrapper from 'admin/components/AdminPageWrapper'

const EditCharityCandidate = () => {
  const [candidate, setCandidate] = useState(undefined)
  const { id } = useParams()

  const fetchCandidate = async () => {
    try {
      const response = await supabase.from('candidates').select().eq('id', id)
      const data = response.data ? response.data[0] : null

      if (data) {
        setCandidate(data)
      }
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    fetchCandidate()
  }, [id])

  return (
    <AdminPageWrapper>
      <CharityCandidateForm candidate={candidate} />
    </AdminPageWrapper>
  )
}

export default EditCharityCandidate
